import React, { useState, useEffect } from 'react'
import { Table } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { budgetFormat } from '../../../utils/formatterUtil'

export default function SubProjectListSatusReportTable({
  schema,
  loading = false,
  onReload = () => {},
  onSelect = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const fs = localStorage.getItem('fontSize')
  const [sortColumn, setSortColumn] = useState('projectCode')
  const [sortType, setSortType] = useState('asc')
  const [loadings, setLoadings] = useState(loading)

  useEffect(() => {
    setTableData(schema?.values)
  }, [schema])

  const onSortData = (sortColumn, sortType) => {
    setLoadings(true)
    if (sortColumn && sortType) {
      var datas = tableData.sort((a, b) => {
        let x = a[sortColumn]
        let y = b[sortColumn]
        console.log('x : ', x, ', y : ', y)
        if (sortType === 'asc') {
          if (x < y) {
            return -1
          }
          if (x > y) {
            return 1
          }

          return 0
        } else {
          if (y < x) {
            return -1
          }
          if (y > x) {
            return 1
          }

          return 0
        }
      })

      setTableData(datas)
    }

    setTimeout(() => {
      setLoadings(false)
      setSortColumn(sortColumn)
      setSortType(sortType)
    }, 300)
  }

  return (
    <>
      <Table
        wordWrap
        autoHeight={tableData.length < 8}
        height={600}
        loading={loadings}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
        data={tableData || []}
        // data={getData()}
        sortColumn={sortColumn}
        sortType={sortType}
        onSortColumn={onSortData}
        style={{ marginTop: '20px' }}
      >
        <Column width={100} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={130} align="left" sortable>
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column width={130} align="left" sortable>
          <HeaderCell>เลขที่สัญญา</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>

        <Column width={200} minWidth={300} flexGrow={1} align="left" sortable>
          <HeaderCell>ชื่อโครงการ</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={120} align="left" sortable>
          <HeaderCell>วันที่อนุมัติ</HeaderCell>
          <Cell dataKey="approvedDate" />
        </Column>

        <Column width={150} align="right" sortable>
          <HeaderCell>งบอนุมัติ</HeaderCell>
          <Cell dataKey="totalBudget">
            {(rowData) => {
              return budgetFormat(rowData.totalBudget)
            }}
          </Cell>
        </Column>

        <Column width={200} align="left" sortable>
          <HeaderCell>สถานะ</HeaderCell>
          <Cell dataKey="projectStatusName" />
        </Column>

        <Column width={200} align="left" sortable>
          <HeaderCell>สถานะย่อย</HeaderCell>
          <Cell dataKey="stepName" />
        </Column>

        <Column width={220} align="left" sortable>
          <HeaderCell>สนับสนุนวิชาการ (พี่เลี้ยง)</HeaderCell>
          {/* <Cell dataKey="coordinatorName" /> */}
          <Cell>
            {(rowData) => {
              var datas = rowData.coordinatorName?.split(',')

              return (
                <>
                  {datas?.map((e, index) => {
                    return (
                      <p>
                        {datas.length > 1 && `${index + 1}.`}
                        {e}
                      </p>
                    )
                  })}
                </>
              )
            }}
          </Cell>
        </Column>

        <Column width={220} align="left" sortable>
          <HeaderCell>ผู้รับทุน</HeaderCell>
          <Cell dataKey="granteeName" />
        </Column>

        <Column width={220} align="left" sortable>
          <HeaderCell>ผู้รับผิดชอบโครงการ</HeaderCell>
          <Cell dataKey="responsinatorName" />
        </Column>

        {/* {!isViewMode && ( */}
        <Column width={120} align="center" fixed="right">
          <HeaderCell>แสดงข้อมูล</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <SaveButton
                  icon="eye"
                  onClick={() => {
                    onSelect(rowData)
                  }}
                >
                  แสดง
                </SaveButton>
              )
            }}
          </Cell>
        </Column>
      </Table>
    </>
  )
}
